import React from 'react';
import TrendText from '@amzn/meridian/trend-text';
import { FormattedMessage } from 'react-intl';
import {
  GoalMetricOption,
  goalMetricMetadataMap,
} from '@amzn/aet-galactus-kit';
import styles from '../AssociateRichCardsStyle.module.css';
import { NO_DATA_LABEL } from '../Util/team';

interface TrendTextIndicatorProps {
  metric: string | undefined;
  label: string;
  trend: string;
  showLongTrendDescription: boolean;
  showNetworkDescription?: boolean;
  isTimeMetric?: boolean;
}

const TrendTextIndicator: React.FC<TrendTextIndicatorProps> = ({
  metric,
  label,
  trend,
  showLongTrendDescription,
  showNetworkDescription = false,
}: TrendTextIndicatorProps): React.ReactElement => {
  let increaseColor = 'positive';
  let decreaseColor = 'negative';
  let adjustedLabel = label;
  const NAN_LABEL = 'NaN';

  if (metric === undefined) return <></>;

  if (
    !goalMetricMetadataMap[metric as keyof typeof GoalMetricOption]
      .isHigherBetter
  ) {
    increaseColor = 'negative';
    decreaseColor = 'positive';
  }

  if (showNetworkDescription) {
    if (label.startsWith('-')) adjustedLabel = adjustedLabel.substring(1);
  }

  return (
    <>
      {trend === 'positive' &&
        (showNetworkDescription ? (
          <TrendText color='secondary'>
            <span className={styles.summaryChange}>
              {adjustedLabel}{' '}
              <FormattedMessage
                id='cs_perfportal_arc_netavg_increase'
                defaultMessage='Above Network Avg'
              />
            </span>
          </TrendText>
        ) : (
          <TrendText arrow='up' color={increaseColor}>
            <span className={styles.summaryChange}>
              {adjustedLabel}
              {showLongTrendDescription && (
                <>
                  {' '}
                  <FormattedMessage
                    id='cs_perfportal_arc_trend_increase'
                    defaultMessage='Increase'
                  />
                </>
              )}
            </span>
          </TrendText>
        ))}

      {trend === 'negative' &&
        (showNetworkDescription ? (
          <TrendText color='secondary'>
            <span className={styles.summaryChange}>
              {adjustedLabel}{' '}
              <FormattedMessage
                id='cs_perfportal_arc_netavg_decrease'
                defaultMessage='Below Network Avg'
              />
            </span>
          </TrendText>
        ) : (
          <TrendText arrow='down' color={decreaseColor}>
            <span className={styles.summaryChange}>
              {adjustedLabel}
              {showLongTrendDescription && (
                <>
                  {' '}
                  <FormattedMessage
                    id='cs_perfportal_arc_trend_decrease'
                    defaultMessage='Decrease'
                  />
                </>
              )}{' '}
            </span>
          </TrendText>
        ))}
      {trend === 'neutral' && (
        <TrendText color='secondary'>
          {!adjustedLabel.includes(NAN_LABEL) ? (
            adjustedLabel.includes(NO_DATA_LABEL) ? (
              <span className={styles.summaryChange}>
                <FormattedMessage
                  id='cs_perfportal_arc_trend_neutral_data_pending'
                  defaultMessage='Data Pending'
                />
              </span>
            ) : (
              <span className={styles.summaryChange}>
                <FormattedMessage
                  id='cs_perfportal_arc_trend_neutral'
                  defaultMessage='No Change'
                />
              </span>
            )
          ) : (
            <span className={styles.summaryChange}>
              <FormattedMessage
                id='cs_perfportal_arc_network_avg_unavilable'
                defaultMessage='Network Avg Unavailable'
              />
            </span>
          )}
        </TrendText>
      )}
    </>
  );
};

export default TrendTextIndicator;
